@if (!useStatusFilter()) {
  <qai-floating-select [options]="assignmentOptions" [placement]="'below-start'" [offset]="4" [shape]="'round'"
    [value]="selectedAssignmentType" (valueChange)="onAssignmentChange($event)"></qai-floating-select>
} @else {
  <qai-searchable-select
    [shape]="'rectangle'"
    [placeholder]="'reportingV2.ASSIGNMENT_STATUS' | transloco"
    [selectionPrefix]="'reportingV2.ASSIGNMENT_STATUS' | transloco | localeLabel"
    [options]="statusOptions"
    [multiselect]="true"
    [value]="selectedStatuses"
    [scopedOptionsSelectionMode]="scopedOptionsSelectionMode"
    [othersTextFormatter]="othersTextFormatter"
    (valueChange)="onStatusChange($event)">
  </qai-searchable-select>
}
